import { createContext } from 'react';

interface LayoutViewContextValue {
  capabilityVersion: string;
  isCommonView: boolean;
  isMobileView: boolean;
  isPortalView: boolean;
  isSharedServiceView: boolean;
  isStandardView: boolean;
  sourceApp: string;
  sourceAppView: string;
}
const LayoutViewContext = createContext<LayoutViewContextValue | null>(null);

let getLayoutViewBridge: () => LayoutViewContextValue;

const LayoutViewBridge = {
  getLayoutViewBridge() {
    return getLayoutViewBridge?.();
  },
  setGetLayoutViewBridge(fn: () => LayoutViewContextValue) {
    getLayoutViewBridge = fn;
  },
};

export { LayoutViewBridge, LayoutViewContext };
